import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 350);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    const form = document.querySelector('[data-testid="enquiry-form"]');
    const packages = document.querySelector("#packages");
    const target = pathname === "/" ? packages : form || packages;
    target?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="sticky-cta-bar"
      className={`fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#071735]/95 px-5 pb-[max(env(safe-area-inset-bottom),0.75rem)] pt-3 backdrop-blur-xl transition-transform duration-300 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="leading-tight">
          <p className="font-display text-base uppercase tracking-wide text-white">
            From $17,990
          </p>
          <p className="text-[11px] font-semibold text-sdh-sky">+ GST · Fixed price</p>
        </div>
        <button
          onClick={handleClick}
          data-testid="sticky-cta-button"
          className="cta-pulse-sky rounded-full bg-sdh-sky px-6 py-3 font-display text-base uppercase tracking-wider text-[#0B1D39]"
        >
          Get My Free Quote
        </button>
      </div>
    </div>
  );
};

export default StickyCTA;
